import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n'; // initialise i18next (side-effect) — must be before App
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
